export const API = {
    GetAllAppointment: "/api/v1/Appointment/GetAllAppointment",
    GetAppointmentDetailsById: "/api/v1/Appointment/GetAppointmentDetailsById"
}